import React from "react";
// import imageUpload from "assets/svgs/imageUpload.svg";
// import removeImg from "assets/svgs/close.svg";
import server from "../../api/server";
import { useEffect } from "react";
// import server from 'api/server';

const ImageUpload = ({ selectedImage, setSelectedImage }) => {
	useEffect(() => {
		if (typeof selectedImage == "object" && selectedImage?.length > 0) {
			setSelectedImage(selectedImage?.[0] || {});
		}
	}, []);

	const imageChange = async e => {
		if (e.target.files && e.target.files.length > 0) {
			const formData = new FormData();
			formData.append("file", e.target.files[0]);
			const { data } = await server().post("/upload", formData);

			setSelectedImage({
				path: data.data?.file?.fullpath,
			});
		}
	};

	const removeSelectedImage = () => {
		setSelectedImage("");
	};

	return (
		<div className="image-uploader image-contain">
			<div className="img-pat d-flex justify-content-evenly align-items-center my-2">
				صورة
				<i className="fas fa-image"></i>
			</div>
			<label>
				{(selectedImage?.path || selectedImage) && (
					<div>
						<img
							src={selectedImage?.path || selectedImage || ""}
							width={160}
							height={160}
							alt=""
						/>
						<span className="removeImg" onClick={removeSelectedImage}>
							{/* <img src={removeImg} alt="" /> */}
							<i className="fas fa-trash"></i>
						</span>
					</div>
				)}
				<input accept="image/*" type="file" onChange={imageChange} />
			</label>
		</div>
	);
};

export default ImageUpload;
